import { AccountTree, Assignment, FlashOn, Message, Pause, PlayArrow, Stop, VerifiedUser } from "@mui/icons-material";

export const formatTitle = (title) => {
  if (!title) return "";

  return title
    .split(/[_ ]+/)
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(" ");
};

export const nodeColors = {
  start: "#4caf50",
  message: "#2196f3",
  flow_message: "#9c27b0",
  trigger: "#ff9800",
  logic: "#f44336",
  end: "#607d8b",
  // Not in ColorsConstants (no teal/purple there); kept with the other node colours
  otp: "#00897b",
};

// Per-node-type override of the category colour: OTP API Connection is purple, not the OTP teal
export const nodeTypeColors = {
  otp_connection: "#5e35b1",
};

export const getNodeColor = (category, nodeTypeKey) =>
  nodeTypeColors[nodeTypeKey] || nodeColors[category] || "#757575";

export const nodeIcons = {
  start: PlayArrow,
  message: Message,
  flow_message: Assignment,
  trigger: FlashOn,
  logic: AccountTree,
  end: Stop,
  otp: VerifiedUser,
};